import {pathToRegexp} from 'path-to-regexp';
import {Routes} from '@src/Constant/routes';
import getPrefixedPattern from './getPrefixedPattern';

const getMatchingRoute = (pathname: string): Routes | null => {
  for (const [routePattern, routeEnum] of Object.entries(Routes)) {
    const regex = pathToRegexp(`${getPrefixedPattern(routeEnum)}`);
    if (regex.test(pathname)) {
      return routeEnum;
    }
  }
  return null;
};

export default getMatchingRoute;
